import React, { useState } from 'react';

import CreateSurveyModal from 'components/module/CreateSurveyModal';
import { CreateSurveyModalProps } from 'components/module/CreateSurveyModal/CreateSurveyModal.view';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { SurveyServiceInstance } from 'services/surveyService';
import { AllErrors } from 'types/Errors';

import { SurveyForm } from './CreateSurvey.props';

const CreateSurvey = (): JSX.Element => {
  // MARK:- Hooks
  const navigate = useNavigate();

  // MARK:- State
  const [errorMessage, setErrorMessage] = useState('');

  const createSurveyMutation = useMutation(SurveyServiceInstance.create, {
    onSuccess: (data) => {
      navigate('/dashboard/survey');
    },
    onError: (error: AllErrors) => {
      setErrorMessage('An unexpected error has occurred!');
    },
  });

  // MARK:- State
  function onSubmit(sections: SurveyForm, title: string, order: string[]) {
    createSurveyMutation.mutate({ sections, title, order });
  }

  const generatedProps: CreateSurveyModalProps = {
    loading: createSurveyMutation.isLoading,
    onSubmit,
  };
  return <CreateSurveyModal {...generatedProps} />;
};

export default CreateSurvey;
